import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface SettingsUIState {
  activeSection: string;
  isMobileMenuOpen: boolean;
  expandedCategories: Set<string>;
  hasUnsavedChanges: boolean;
  isSaving: boolean;

  setActiveSection: (section: string) => void;
  setIsMobileMenuOpen: (isOpen: boolean) => void;
  toggleCategory: (category: string) => void;
  expandCategory: (category: string) => void;
  setHasUnsavedChanges: (hasChanges: boolean) => void;
  setIsSaving: (isSaving: boolean) => void;
}

export const useSettingsUIStore = create<SettingsUIState>()(
  devtools(
    (set, get) => ({
      activeSection: "workers",
      isMobileMenuOpen: false,
      expandedCategories: new Set(["salon", "booking-ops"]),
      hasUnsavedChanges: false,
      isSaving: false,

      setActiveSection: (section) => set({ activeSection: section }),
      setIsMobileMenuOpen: (isOpen) => set({ isMobileMenuOpen: isOpen }),
      toggleCategory: (category) => {
        const current = get().expandedCategories;
        const newExpanded = new Set(current);
        if (newExpanded.has(category)) {
          newExpanded.delete(category);
        } else {
          newExpanded.add(category);
        }
        set({ expandedCategories: newExpanded });
      },
      expandCategory: (category) => {
        const current = get().expandedCategories;
        const newExpanded = new Set(current);
        newExpanded.add(category);
        set({ expandedCategories: newExpanded });
      },
      setHasUnsavedChanges: (hasChanges) => set({ hasUnsavedChanges: hasChanges }),
      setIsSaving: (isSaving) => set({ isSaving }),
    }),
    { name: "settings-ui-store" }
  )
);
